module.exports = __webpack_public_path__ + "static/media/cd2-icon-compliant.283c205f.svg";